"use client";
import { n as e } from "./neonSlam-Cs7KV0j3.js";
import { n as t } from "./neonPack-Wl0QaZuR.js";
import { t as n } from "./retailBox-VFadGbgZ.js";
//#region src/allOpeners.ts
function r() {
	e(), t(), n();
}
//#endregion
export { r as registerAllOpeners };

//# sourceMappingURL=openers.js.map